// extracted by mini-css-extract-plugin
module.exports = {"landscape-mode":"landscape-mode_landscape-mode__W5z4J","info":"landscape-mode_info__NXMjZ"};